export default __webpack_public_path__ + "static/sunchang1-a3f7d21fabaa824aaaf320e9f2850bc2.jpg";